module.exports = __webpack_public_path__ + "public/images/program/program-9.0703cccf1c09f245c18bc0306dbbe2f3.jpg";